import React from 'react';
import { NostoTagging } from './Provider';
const NostoCart = ({ promise, data }) => (React.createElement(NostoTagging, { id: "cart", promise: promise, data: data }, data => {
    const { lineItems, restoreLink } = data;
    return (React.createElement("div", { style: { display: 'none' } },
        React.createElement("div", { className: "nosto_cart" },
            lineItems &&
                lineItems.map((item) => (React.createElement("span", { className: "line_item", key: item.id },
                    React.createElement("span", { className: "product_id" }, item.productId),
                    React.createElement("span", { className: "quantity" }, item.quantity),
                    React.createElement("span", { className: "name" }, item.name),
                    React.createElement("span", { className: "unit_price" }, item.price),
                    React.createElement("span", { className: "price_currency_code" }, item.currencyCode)))),
            restoreLink && React.createElement("div", { className: "restore_link" }, restoreLink))));
}));
export default NostoCart;
//# sourceMappingURL=Cart.js.map